import { icons } from './icons';
export default function importImage({ upload, }) {
    const handleFiles = async (files, utils) => {
        const urls = await upload(files);
        utils.appendBlock(urls.map((url) => `![](${url})`).join('\n\n'));
    };
    return {
        toolbar: {
            image: {
                tooltip: 'Image',
                icon: icons.image,
                onClick({ utils }) {
                    const input = document.createElement('input');
                    input.type = 'file';
                    input.multiple = true;
                    input.accept = 'image/*';
                    input.addEventListener('input', (e) => {
                        var _a;
                        const files = Array.from((_a = input.files) !== null && _a !== void 0 ? _a : []).filter(
                        // input accept would not work if 'all files' is selected
                        (item) => item.type.startsWith('image/'));
                        if (files === null || files === void 0 ? void 0 : files.length) {
                            handleFiles(files, utils);
                        }
                    });
                    input.click();
                },
            },
        },
        editorEffect({ editor, utils }) {
            const handler = async (_, e) => {
                var _a, _b;
                const itemList = e instanceof ClipboardEvent
                    ? (_a = e.clipboardData) === null || _a === void 0 ? void 0 : _a.items : (_b = e.dataTransfer) === null || _b === void 0 ? void 0 : _b.items;
                const files = Array.from(itemList !== null && itemList !== void 0 ? itemList : [])
                    .map((item) => {
                    if (item.type.startsWith('image/')) {
                        return item.getAsFile();
                    }
                })
                    .filter((f) => f != null);
                if (files.length) {
                    e.preventDefault();
                    await handleFiles(files, utils);
                }
            };
            editor.on('paste', handler);
            editor.on('drop', handler);
            return () => {
                editor.off('paste', handler);
                editor.off('drop', handler);
            };
        },
    };
}
